import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { Dialog, DialogTitle, Grid, IconButton, Typography } from '@material-ui/core';
import { createStyles, withStyles, Theme, WithStyles } from '@material-ui/core/styles';
import CloseIcon from '@material-ui/icons/Close';

import { LeaderboardConfig } from 'api';
import { Queries } from 'components';
import PointTable from './PointTable';

const styles = (theme: Theme) =>
  createStyles({
    title: {
      marginBottom: 0,
      paddingBottom: theme.spacing(2),
    },
    text: {
      borderBottom: 0,
    },
  });

interface IProps extends WithStyles<typeof styles> {
  open: boolean;
  onClose: () => void;
  config: LeaderboardConfig;
}

const LeaderboardPointDialog: FC<IProps> = ({ classes, config, open, onClose }) => {
  const { t } = useTranslation();
  const { id, title } = config;

  return (
    <Dialog fullWidth open={open} onClose={onClose}>
      <DialogTitle disableTypography className={classes.title}>
        <Grid container direction="column" wrap="nowrap" spacing={1}>
          <Grid item>
            <Typography variant="subtitle2">{title}</Typography>
          </Grid>
          <Grid item>
            <Typography>{t('leaderboard:actions')}</Typography>
          </Grid>
        </Grid>
        <IconButton onClick={onClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <Queries.GetLeaderboardConfigScores variables={{ id }}>
        {eventScores => <PointTable eventScores={eventScores} />}
      </Queries.GetLeaderboardConfigScores>
    </Dialog>
  );
};

export default withStyles(styles)(LeaderboardPointDialog);
